import { pipe } from 'fp-ts/lib/function';

import * as R from 'fp-ts/Record';
import * as O from 'fp-ts/Option';

R.lookup;

export const getVoteLabel = (voteName: string): string =>
  pipe(
    R.lookup(voteName, {
      motm: 'MoM',
      dotd: 'DoD',
    }),
    O.getOrElse(() => voteName),
  );

export const getVoteEmoji = (voteName: string): string =>
  pipe(
    R.lookup(voteName, {
      motm: '🌟',
      dotd: '💩',
    }),
    O.getOrElse(() => '🗳'),
  );
